(function () {
    'use strict';

    class CarruselVideosLicolovers {
        constructor(wrapper) {
            this.wrapper         = wrapper;
            this.slider          = wrapper.querySelector('.slider-videos_VideosLicolovers');
            this.slides          = Array.from(this.slider.querySelectorAll('.slide-videos_VideosLicolovers'));
            this.dots            = Array.from(document.querySelectorAll('.dots-container-dot_VideosLicolovers'));
            this.prevBtn         = wrapper.querySelector('.prev-btn_VideosLicolovers');
            this.nextBtn         = wrapper.querySelector('.next-btn_VideosLicolovers');
            this.total           = this.slides.length;
            this.currentIndex    = 0;
            this.touchStartX     = 0;
            this.touchCurrentX   = 0;
            this.touchStartOffset = 0; 
            this.isDragging      = false;
            this.SWIPE_THRESHOLD = 50;

            this._bindEvents();
            this.goTo(0);
        }

        _getOffset(index) {
            const wrapperWidth = this.wrapper.offsetWidth;
            const slideWidth   = this.slides[0].offsetWidth;

            // Primer slide: pegado a la izquierda
            if (index === 0) {
                return 0;
            }

            // Último slide: pegado a la derecha
            if (index === this.total - 1) {
                const totalSliderWidth = slideWidth * this.total;
                return totalSliderWidth - wrapperWidth;
            }

            // Slides intermedios: centrados
            const slideLeft    = slideWidth * index;
            const centerOffset = (wrapperWidth - slideWidth) / 2;
            return slideLeft - centerOffset;
        }

        _getCurrentTranslateX() {
            const transform = window.getComputedStyle(this.slider).transform;
            if (!transform || transform === 'none') return 0;
            const matrix = transform.match(/matrix.*\((.+)\)/);
            if (!matrix) return 0;
            return parseFloat(matrix[1].split(', ')[4]);
        }

        _getMostVisibleIndex() {
            const wrapperRect = this.wrapper.getBoundingClientRect();

            let bestIndex    = 0;
            let bestVisible  = -1;

            this.slides.forEach((slide, i) => {
                const slideRect = slide.getBoundingClientRect();

                const visibleLeft  = Math.max(slideRect.left,  wrapperRect.left);
                const visibleRight = Math.min(slideRect.right, wrapperRect.right);
                const visibleWidth = Math.max(0, visibleRight - visibleLeft);

                if (visibleWidth > bestVisible) {
                    bestVisible = visibleWidth;
                    bestIndex   = i;
                }
            });

            return bestIndex;
        }

        goTo(index) {
            if (index < 0 || index >= this.total) return;

            this.currentIndex = index;

            this.slider.style.transition = 'transform 0.4s ease-out';

            const offset = this._getOffset(index);
            this.slider.style.transform = `translateX(-${offset}px)`;

            this.dots.forEach((dot, i) => {
                dot.classList.toggle('active_VideosLicolovers', i === this.currentIndex);
            });

            this.prevBtn.style.visibility = this.currentIndex === 0              ? 'hidden' : 'visible';
            this.nextBtn.style.visibility = this.currentIndex === this.total - 1 ? 'hidden' : 'visible';
        }

        _bindEvents() {
            this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
            this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));

            this.dots.forEach((dot, i) => {
                dot.addEventListener('click', () => this.goTo(i));
            });

            this.slider.addEventListener('touchstart', (e) => {
                this.isDragging       = true;
                this.touchStartX      = e.changedTouches[0].clientX;
                this.touchCurrentX    = e.changedTouches[0].clientX;
                this.touchStartOffset = -this._getCurrentTranslateX();

                this.slider.style.transition = 'none';
            }, { passive: true });

            // ── Touch: movimiento en tiempo real ──
            this.slider.addEventListener('touchmove', (e) => {
                if (!this.isDragging) return;

                this.touchCurrentX = e.changedTouches[0].clientX;
                const diff         = this.touchStartX - this.touchCurrentX;
                const newOffset    = this.touchStartOffset + diff;

                this.slider.style.transform = `translateX(-${newOffset}px)`;
            }, { passive: true });

            // Suelta el dedo → snap ──
            this.slider.addEventListener('touchend', () => {
                if (!this.isDragging) return;
                this.isDragging = false;

                // Detecta qué slide ocupa más espacio y hace snap a él
                const snapIndex = this._getMostVisibleIndex();
                this.goTo(snapIndex);
            }, { passive: true });

            // Recalcula si cambia el tamaño de pantalla
            window.addEventListener('resize', () => this.goTo(this.currentIndex));
        }
    }

    function initCarruselVideosLicolovers() {
        const wrapper = document.querySelector('.slider-videos-wrapper_VideosLicolovers');
        if (!wrapper) return;
        new CarruselVideosLicolovers(wrapper);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCarruselVideosLicolovers);
    } else {
        initCarruselVideosLicolovers();
    }
})();